let IconButton = require("./IconButton");

let Slider = function (props) {
  let {
    value = 1,
    label,
    onChange,
    min = 1,
    max = 10,
    step = 1,
    disabled = false,
    width = 150
  } = props;

  return (
    <div className="mc-slider">
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        disabled={disabled}
        step={step}
        style={{ width }}
        onChange={(evt) => onChange(parseInt(evt.target.value))}/>
      <IconButton
        scale={0.8}
        icon="minus"
        onPress={() => onChange(Math.max(min, Math.min(value - step, max)))}
        disabled={disabled || value <= min}/>
      <IconButton
        scale={0.8}
        icon="plus"
        onPress={() => onChange(Math.max(min, Math.min(value + step, max)))}
        disabled={disabled || value >= max}/>
      <span>{label || value}</span>
    </div>
  );
};

module.exports = Slider;